import './main.scss'
import 'driver.js/dist/driver.css'

// import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import * as Sentry from '@sentry/vue'

import './plugins/bootstrap-vue'
import './plugins/vue-multiselect'
import './plugins/fontawesome'

import './class-component-hooks'

import App from './App.vue'
import router from './router'
import store from './store'

import './vue-vee-validate/validation-config'
import './filter-date'
import './directives/select-on-focus'
import './directives/focus-next-on-enter'
import './extend-multiselect'

import i18n from './lang/index'
import BaseBtn from '@/components/base-btn.vue'
import AppDatepicker from '@/components/AppDatepicker.vue'

Vue.config.productionTip = false
Vue.component('BaseBtn', BaseBtn)
Vue.component('AppDatepicker', AppDatepicker)

if (process.env.VUE_APP_SENTRY_DSN) {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN
  })
}

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
